$(function () {
    if (!!($('.team').html())) {
        $('body').addClass('has-modal');
    }
	$('.team').each(function () {
		var self = $(this),
			img = $(self).find('img'),
			classList = $(self).attr('class').split(' '),
			index = classList.length,
			klass = classList[index - 1],
            bioSelector = '.bio.' + klass,
			bio = $(bioSelector).find('.HtmlContent')
            $(self).find('.HtmlContent').wrapInner('<div class="text-container" />');
            $(self).find('img').prependTo($(self).find('.HtmlContent'));
            $(self).find('img').wrap('<div class="img-container" />');
            
            if (!!$(bio).html()) {
            
                var	img = $(self).find('img'),
                    name = $(self).find('h3'),
                    position = $(self).find('h4'),
                    link = "<button type='button' onclick='openModal(\"" + klass + "\");'></button>",
                    bioImage = $(img).clone();
                    
                $(bio).wrapInner('<div class="bio-text" />');
                $(bioImage).prependTo(bio);
                $(bioImage).wrap('<div class="bio-image" />');
                $(position).clone().prependTo($(bio).find('.bio-text'));
                $(name).clone().prependTo($(bio).find('.bio-text'));
                    
                // $(self).find('.HtmlContent').append(link);
                $(self).wrapInner(link);
            }   

	});
	
	$('.bio').prepend('<button type="button" onclick="closeModal();" class="close-modal"><span class="sr-only">Close</span></button>');
	
	$(document).keyup(function (e){
		if (e.keyCode == 27) {
			closeModal();
		}
	});
	$(document).click(function (e) {
		if ($(e.target).hasClass('bio-modal-open')) {
			closeModal();
		}
	});

$('.team .HtmlContent .img-container img').each(function () {
    const img = this;
    $(img).on('load', function () {
        const w = img.naturalWidth;
        const h = img.naturalHeight;

        if (w > h) {
            $(img).addClass('wide-img');
        } else if (h > w) {
            $(img).addClass('tall-img');
        }
    });
    // Handle cached images that may not fire load again
    if (img.complete) {
        $(img).trigger('load');
    }
});

});

window.openModal = function(val) {
	var klass = '.bio.' + val;
	$(klass).addClass('open');
	$('body').addClass('bio-modal-open');
}

window.closeModal = function() {
	$('.bio').removeClass('open');
	$('body').removeClass('bio-modal-open');
}